import { HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { TradingServiceStrategy } from './trading-service-strategy.service';
import { TRADING_PLATFORM } from '../../utils/trading-constants';
import { Injectable } from "@angular/core";

const httpOptions = {
  headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
  })
};

@Injectable()
export class ProfessionalTradingServiceStrategy extends TradingServiceStrategy {

    private static SUPPORTED_PLATFORM = TRADING_PLATFORM.PROFESSIONAL;

    support(platform: string): boolean {
        return ProfessionalTradingServiceStrategy.SUPPORTED_PLATFORM === platform;
    }

    public getTradingSettings(ibdId: string, assetType: string, role?: string) {
        if (role) {
            return this.http.get(this.getBaseUrl() + `/${ibdId}/${assetType}/trade-defaults?role=${role}`, httpOptions);
        } else {
            return this.http.get(this.getBaseUrl() + `/${ibdId}/${assetType}/trade-defaults`, httpOptions);
        }
    }

    // dummy implementation to statisfy compiler
    // applicable only for retail.
    public getAccounts(): Observable<any> {
        let resp = {
            errorCode: 0,
            errorDescription: 'SUCCESS',
            errorMessage: null,
            response: []
        };

        return of(resp);
    }

    getExchangeAgreementNavData(): Observable<any> {
        let resp = {
            errorCode: 0,
            errorDescription: 'SUCCESS',
            errorMessage: null,
            response: []
        };

        return of(resp);
    }
    opraData(NONPROFDATA: any, NASDAQDATA: any, OPRADATA: any, NSPDDATA: any, PROFDATA: any): Observable<any> {
        let resp = {
            errorCode: 0,
            errorDescription: 'SUCCESS',
            errorMessage: null,
            response: []
        };

        return of(resp);
    }

    public getExchangeDetails(symId: string): Observable<any> {
        return this.http.get(this.getBaseUrl() + '/' + symId + '/exchangeDetails', httpOptions);
    }

    public getTrailingDetails(): string {
        return '?includeTrailers=false';
    }
}
